/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ refund: NonNullable<unknown> }} Sales_Return_Fee_EffectInputs */

const vi_sales_return_fee_effect = /** @type {(inputs: Sales_Return_Fee_EffectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khách còn được hoàn tối đa ${i?.refund}.`)
};

/**

* @param {Sales_Return_Fee_EffectInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_fee_effect = /** @type {((inputs: Sales_Return_Fee_EffectInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Fee_EffectInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_fee_effect(inputs)
});